import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UUID } from 'angular2-uuid';
import { FileUploadService } from 'src/app/shared/services/fileupload.service';
import { AuthenticateService } from 'src/app/shared/services/authenticate.service';
import { Transportservice } from 'src/app/shared/services/transport.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import { CognitoService } from 'src/app/shared/services/cognito.service';

@Component({
  selector: 'app-sub-type',
  templateUrl: './sub-type.component.html',
  styleUrls: ['./sub-type.component.sass']
})
export class SubTypeComponent implements OnInit {

  showSubType: boolean = false;
  subTypeArray: any = [];
  subObj: any = {};
  loading: boolean;
  globalImgUrl: string;
  groupName: string;
  subTypeForm: FormGroup;
  type: string = 'save';
  showPage: boolean = true;
  collectionSize: any;
  searchStr: string = '';
  skip: number;
  page = 1;
  previousPage: any;
  subTypeImage: any;
  imageUploadService: string;
  subTypeUrl: string = '';
  packingTypeArray: any = [];

  constructor(private formBuilder: FormBuilder,
    private transportService: Transportservice,
    private fileUploadService: FileUploadService,
    private cognitoService: CognitoService,
    private authService: AuthenticateService,) { }

  ngOnInit() {
    this.cognitoService.getCurrentUserToken().then((res:any) => {
      this.groupName = res.attributes.family_name;
      this.globalImgUrl = this.authService.s3url();
      this.globalImgUrl = this.authService.s3url();
      this.getAllSubTypes(0);
      this.getAllPackingTypes();
    })
    this.type = 'save';
    this.subTypeForm = this.formBuilder.group({
      packingType: ['', Validators.required],
      subType: ['', Validators.required],
      subTypeDescription: ['', Validators.required],
    });
  }
  getAllPackingTypes() {
    let obj = {
      group: this.groupName
    }
    this.transportService.getPackingType(obj).then((data: any) => {
      if (data.length > 0) {
        for (let i = 0; i < data.length; i++) {
          this.packingTypeArray.push(data[i]);
        }
      }
    })
  }

  getAllSubTypes(pskip) {
    this.loading = true;
    this.showPage = true;
    var count = { group: this.groupName }
    this.transportService.getSubTypeCount(count).then((data: any) => {
      console.log("subType COUNT : ", data);
      if (data.length > 0) {
        this.collectionSize = data[0].size
        var options = {
          group: this.groupName,
          options: {
            limit: 20,
            sortFields: { createTs: -1 },
            skip: pskip
          }
        }
        this.subTypeArray = [];
        this.transportService.getSubTypeData(options).then((data: any) => {
          console.log("subType Data == ", data);
          if (data.length > 0) {
            this.subTypeArray = data;
            console.log("subTypeArray", this.subTypeArray)
            this.loading = false;
          } else {
            this.loading = false;
          }
        })
      } else {
        this.subTypeArray = [];
        this.loading = false;
      }
    });
  }

  loadPage(pageNumber: number) {
    console.log("page number ", pageNumber, this.previousPage)
    if (pageNumber !== this.previousPage) {
      this.skip = (pageNumber * 20) - 20;
      this.previousPage = pageNumber;
      this.getAllSubTypes(this.skip);
    }
  }

  onChangePackingType(packingType) {
    console.log("selected packingType Id", packingType);
    let type = this.packingTypeArray.filter(item => item.packingTypeId == packingType);
    console.log("type", type);
    console.log("packingType", type[0].packingType);
    this.subObj.packingType = type[0].packingType;
  }

  onImgError(event) {
    event.target.src = this.globalImgUrl + 'agri_logo.png';
  }

  imageInput(event) {
    console.log("event : ", event);
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]); // read file as data url
      reader.onload = (event: any) => { // called once readAsDataURL is completed
        this.subTypeUrl = event.target.result;
      }
      let iuuid = UUID.UUID();
      this.imageUploadService = 'var_' + iuuid + "." + event.target.files.item(0).type.split('/')[1];
      this.subTypeImage = event.target.files[0]
      console.log("subTypeImage", this.subTypeImage)
    }
  }

  uploadFileToActivity() {
    console.log("dd ", this.imageUploadService, this.subTypeImage)
    if (this.subTypeImage != '') {
      // this.registerService.postFile(this.subTypeImage, this.imageUploadService).then(data => {
      // }, error => {
      //   console.log(error);
      // });
      this.fileUploadService.uploadFile(this.subTypeImage, this.imageUploadService);
    }
  }

  handleInput(e) {
    if (e.which === 32 && e.target.selectionStart === 0) {
      return false;
    }
  }

  addSubType() {
    this.type = 'save';
    this.subTypeUrl = '';
    this.subTypeForm.reset();
    this.showSubType = true;
  }

  editSubType(subData) {
    this.subTypeUrl = '';
    console.log("sub type Data", subData);
    this.type = 'update';
    this.showSubType = true;
    this.subObj = subData;
    this.subTypeUrl = this.globalImgUrl + this.subObj.subTypeImage;
    console.log("subObj", this.subObj);
  }

  cancelSubType() {
    this.subTypeForm.reset();
    this.subTypeUrl = '';
    this.showSubType = false;
    this.getAllSubTypes(0);
  }

  saveSubTypeData() {
    this.loading = true;
    let uuid = UUID.UUID();
    this.subObj.subTypeId = uuid;
    this.subObj.subTypeImage = this.imageUploadService;
    this.subObj.group = this.groupName;
    console.log("subObj : ", this.subObj);
    this.transportService.createSubType(this.subObj).then((data: any) => {
      console.log("save subType result : ", data);
      if (this.subTypeImage != undefined) {
        this.uploadFileToActivity();
      }
      if (data) {
        Swal({ title: "saved successfully!" });
        this.type = 'save';
        this.subTypeUrl = '';
        this.subTypeForm.reset();
        this.showSubType = false;
        this.getAllSubTypes(0);
      } else {
        this.loading = false;
        Swal.fire(
          'Error',
          'Data not Submitted (please contact admin)',
          'error'
        )
      }
    })
  }

  updateSubTypeData() {
    this.loading = true;
    this.subObj['subTypeImage'] = this.imageUploadService != undefined ? this.imageUploadService : this.subObj.subTypeImage;
    console.log("update subObj", this.subObj);
    this.transportService.updateSubType(this.subObj).then((data: any) => {
      console.log("updatepacking result : ", JSON.stringify(data));
      if (this.subTypeImage != undefined) {
        this.uploadFileToActivity();
      }
      if (data) {
        this.type = 'save';
        this.subTypeUrl = '';
        this.subTypeForm.reset();
        this.showSubType = false;
        this.getAllSubTypes(0);
      } else {
        this.loading = false;
        Swal.fire(
          'Error',
          'Data not updated (please contact admin)',
          'error'
        )
      }
    })
  }

  searchBySubType() {
    if (this.searchStr != '') {
      var obj = {
        group: this.groupName,
        field: 'subType',
        text: this.searchStr,
        tableName: 'transportSubType',
      };
      console.log("search obj : ", obj)
      // this.toolService.getRegex(obj).then((data: any) => {
      //   console.log("searched", data);
      //   this.searchStr = '';
      //   this.subTypeArray = [];
      //   if (data.length > 0) {
      //     this.subTypeArray = data;
      //     this.showPage = false;
      //     console.log("subTypeArray", this.subTypeArray);
      //   }
      //   else {
      //     this.showPage = false;
      //   }
      // })
    }
  }

}
